import { useState } from "react";
import toast from "react-hot-toast";
import { FiX, FiFile } from "react-icons/fi";
import homeworkService from "../../services/homeworkService";

const getStudentName = (student) =>
    student?.fullName || student?.name || student?.displayName || "Student";

export default function GradeModal({ homework, entry, onClose, onSuccess }) {
    const [marksObtained, setMarksObtained] = useState(
        entry.submission?.marksObtained ?? "",
    );
    const [feedback, setFeedback] = useState(entry.submission?.feedback ?? "");
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (marksObtained === "" || Number(marksObtained) < 0) {
            return toast.error("Enter valid marks");
        }
        if (homework.maxMarks && Number(marksObtained) > homework.maxMarks) {
            return toast.error(`Marks cannot exceed ${homework.maxMarks}`);
        }

        setSaving(true);
        try {
            await homeworkService.gradeSubmission(entry.submission._id, {
                marksObtained: Number(marksObtained),
                feedback,
            });
            toast.success("Graded successfully");
            onSuccess();
        } catch (err) {
            toast.error(err.response?.data?.message || "Failed to grade submission");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Grade — {getStudentName(entry.student)}</h2>
                    <button className="btn btn-icon" onClick={onClose}>
                        <FiX />
                    </button>
                </div>

                <div className="modal-body">
                    {entry.submission?.submittedText && (
                        <div className="form-row">
                            <label>Submitted Answer</label>
                            <div
                                style={{
                                    padding: "0.6rem",
                                    background: "var(--bg-subtle, #f8fafc)",
                                    borderRadius: 6,
                                    fontSize: 13,
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {entry.submission.submittedText}
                            </div>
                        </div>
                    )}

                    {entry.submission?.attachments?.length > 0 && (
                        <div className="form-row">
                            <label>Attachments</label>
                            {entry.submission.attachments.map((a, i) => (
                                <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
                                    <FiFile />
                                    <a href={a.url} target="_blank" rel="noreferrer">
                                        {a.fileName}
                                    </a>
                                </div>
                            ))}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-row">
                            <label>Marks Obtained {homework.maxMarks ? `(out of ${homework.maxMarks})` : ""} *</label>
                            <input
                                type="number"
                                min={0}
                                max={homework.maxMarks || undefined}
                                value={marksObtained}
                                onChange={(e) => setMarksObtained(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-row">
                            <label>Feedback</label>
                            <textarea
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                rows={3}
                                placeholder="Optional feedback for the student"
                            />
                        </div>

                        <div className="form-actions">
                            <button type="button" className="btn btn-outline" onClick={onClose}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary" disabled={saving}>
                                {saving ? "Saving..." : "Save Grade"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
